<zt-textinput [config]="config" (onChange)="onChange($event)"></zt-textinput>
